import { Link } from "react-router-dom";
import { Youtube, Twitch, Instagram, Facebook, Twitter, Music2, Zap, Mail } from "lucide-react";
import { Logo } from "@/components/common/Logo";
import { NAV_LINKS, SITE, SOCIAL_LINKS, isPlaceholder } from "@/config/site";
import { toast } from "sonner";

const ICONS = { youtube: Youtube, twitch: Twitch, kick: Zap, tiktok: Music2, instagram: Instagram, x: Twitter, facebook: Facebook };

export const Footer = () => {
  const year = new Date().getFullYear();

  const handleSocialClick = (e, link) => {
    if (isPlaceholder(link.url)) {
      e.preventDefault();
      toast(`${link.name} link goes here — add the real URL in config/site.js`);
    }
  };

  return (
    <footer data-testid="site-footer" className="border-t border-border-dark bg-brand-black text-white">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-12">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <Logo />
            <p className="mt-4 max-w-sm text-sm text-white/50">Text goes here</p>
            <div className="mt-6 flex flex-wrap gap-3">
              {SOCIAL_LINKS.map((link) => {
                const Icon = ICONS[link.id];
                return (
                  <a
                    key={link.id}
                    href={isPlaceholder(link.url) ? "#" : link.url}
                    onClick={(e) => handleSocialClick(e, link)}
                    target={isPlaceholder(link.url) ? undefined : "_blank"}
                    rel="noopener noreferrer"
                    aria-label={link.name}
                    data-testid={`footer-social-${link.id}`}
                    className="inline-flex h-10 w-10 items-center justify-center border border-border-dark text-white/60 transition-colors hover:border-brand-purple hover:text-brand-purple"
                  >
                    <Icon className="h-4 w-4" />
                  </a>
                );
              })}
            </div>
          </div>

          <div>
            <p className="font-subheading text-xs font-semibold uppercase tracking-widest text-white/40">Explore</p>
            <ul className="mt-4 space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} data-testid={`footer-nav-${link.label.toLowerCase()}`} className="text-sm text-white/60 hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-subheading text-xs font-semibold uppercase tracking-widest text-white/40">Contact</p>
            <ul className="mt-4 space-y-3 text-sm text-white/60">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 shrink-0" />
                <span data-testid="footer-contact-email">{SITE.contactEmail}</span>
              </li>
              <li>
                <Link to="/privacy-policy" data-testid="footer-privacy-link" className="hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" data-testid="footer-cookie-link" className="hover:text-white transition-colors">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" data-testid="footer-terms-link" className="hover:text-white transition-colors">
                  Terms &amp; Conditions
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-2 border-t border-border-dark pt-8 text-xs text-white/30 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} WomensMatchDayLive. All rights reserved.</p>
          <p>Grassroots women&apos;s football commentary &amp; live coverage — UK.</p>
        </div>
      </div>
    </footer>
  );
};
